var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33333 2.66669L26.6667 2.66669C27.0203 2.66669 27.3594 2.80716 27.6095 3.05721C27.8595 3.30726 28 3.6464 28 4.00002V29.3334C28 29.8726 27.6751 30.3588 27.1769 30.5652C26.6787 30.7716 26.1052 30.6575 25.7239 30.2762L24 28.5523L22.2761 30.2762C21.7554 30.7969 20.9112 30.7969 20.3905 30.2762L18.6667 28.5523L16.9428 30.2762C16.4221 30.7969 15.5779 30.7969 15.0572 30.2762L13.3333 28.5523L11.6095 30.2762C11.3594 30.5262 11.0203 30.6667 10.6667 30.6667C10.313 30.6667 9.97391 30.5262 9.72386 30.2762L8 28.5523L6.27614 30.2762C5.89481 30.6575 5.32132 30.7716 4.82309 30.5652C4.32486 30.3588 4 29.8726 4 29.3334L4 4.00002C4 3.26364 4.59695 2.66669 5.33333 2.66669ZM6.66667 5.33335L6.66667 26.1144L7.05719 25.7239C7.30724 25.4738 7.64638 25.3334 8 25.3334C8.35362 25.3334 8.69276 25.4738 8.94281 25.7239L10.6667 27.4477L12.3905 25.7239C12.6406 25.4738 12.9797 25.3334 13.3333 25.3334C13.687 25.3334 14.0261 25.4738 14.2761 25.7239L16 27.4477L17.7239 25.7239C18.2446 25.2032 19.0888 25.2032 19.6095 25.7239L21.3333 27.4477L23.0572 25.7239C23.5779 25.2032 24.4221 25.2032 24.9428 25.7239L25.3333 26.1144V5.33335L6.66667 5.33335Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 9.33335C13.3333 8.59697 13.9303 8.00002 14.6667 8.00002L21.3333 8.00002C22.0697 8.00002 22.6667 8.59697 22.6667 9.33335C22.6667 10.0697 22.0697 10.6667 21.3333 10.6667L14.6667 10.6667C13.9303 10.6667 13.3333 10.0697 13.3333 9.33335Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 13.3334C13.3333 12.597 13.9303 12 14.6667 12L21.3333 12C22.0697 12 22.6667 12.597 22.6667 13.3334C22.6667 14.0697 22.0697 14.6667 21.3333 14.6667L14.6667 14.6667C13.9303 14.6667 13.3333 14.0697 13.3333 13.3334Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 21.3334C9.33333 20.597 9.93029 20 10.6667 20L21.3333 20C22.0697 20 22.6667 20.597 22.6667 21.3334C22.6667 22.0697 22.0697 22.6667 21.3333 22.6667L10.6667 22.6667C9.93029 22.6667 9.33333 22.0697 9.33333 21.3334Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33335C12 10.0697 11.403 10.6667 10.6667 10.6667C9.93029 10.6667 9.33333 10.0697 9.33333 9.33335C9.33333 8.59697 9.93029 8.00002 10.6667 8.00002C11.403 8.00002 12 8.59697 12 9.33335Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3334C12 14.0697 11.403 14.6667 10.6667 14.6667C9.93029 14.6667 9.33333 14.0697 9.33333 13.3334C9.33333 12.597 9.93029 12 10.6667 12C11.403 12 12 12.597 12 13.3334Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.4b31b0d75eec00d3cf16c4a42aff219f.svg";
export { ForwardRef as ReactComponent };